import { Box, Button, DialogProps } from "@mui/material";
import useCaseNotes from "../../../hooks/useCaseNote";
import { useSnackbarHelper } from "../../components/Snackbar";
import BasicModal from "../../components/modal/BasicModal";
interface Props extends DialogProps {
  onClose: () => void;
  id: string;
  refetchCaseNotes: any;
}

const DeleteUserModal = ({
  onClose,
  id,
  refetchCaseNotes,
  ...props
}: Props) => {
  const showSnackbar = useSnackbarHelper();
  const { deleteCaseNote, deleteLoading } = useCaseNotes({});
  const onSubmit = async () => {
    try {
      const data: any = await deleteCaseNote(id);
      const message = data?.message || "Success";
      showSnackbar(message, "success");
      refetchCaseNotes();
      onClose();
    } catch (error: any) {
      const message = error?.response?.data?.message || "An error occurred";

      showSnackbar(message, "error");
    }
  };

  return (
    <Box>
      <BasicModal
        onClose={onClose}
        title="Delete Case Note"
        content="Do you really want to delete this case note? "
        isLoader={deleteLoading}
        loadingTitle="Loading..."
        actions={
          <>
            <Button
              variant="contained"
              color="error"
              sx={{ textTransform: "capitalize" }}
              onClick={onSubmit}
              disabled={deleteLoading}
            >
              Delete
            </Button>
            <Button
              color="error"
              variant="outlined"
              sx={{ textTransform: "capitalize" }}
              onClick={() => onClose()}
              disabled={deleteLoading}
            >
              Cancel
            </Button>
          </>
        }
        {...props}
      />
    </Box>
  );
};

export default DeleteUserModal;
